var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from 'lit';
import { property, query } from 'lit/decorators.js';
import { customElement, PICBase, PICCheckBox, PICSelector, PICText, PICSuggestion, PICNumber, PICTextArea } from '../Internals';
import { computePosition, platform, offset } from '@floating-ui/dom';
import { offsetParent } from 'composed-offset-position';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
/*export interface PICErrorData{
    resArr: PICValidateResult[];
}*/
let PICError = class PICError extends PICBase {
    constructor() {
        super(...arguments);
        this.errorMessages = [];
        this.showErrorBox = false;
        this.state = 'hidden';
    }
    set PICErrorData(data) {
        if (data) {
            this.errorMessages = data;
            this.render();
        }
    }
    ;
    willUpdate() {
        if (this.errorMessages.length == 0) {
            if (this.state !== 'hidden')
                this.state = 'fade-out';
        }
        else {
            this.state = 'fade-in';
        }
    }
    static get styles() {
        const defaultStyle = css `
        :host{
            --pic-errorTop: calc(var(--pic-densityLowInputHeight) + var(--pic-densityLowInputHeight));
            --pic-errorLeft: 0px;
            --pic-errorArrowLeft: 55px;
            --pic-errorArrowBottom: 95px;
            --pic-errorArrowTop: -20px;
            --pic-errorArrowSize: 10px;
            --pic-errorArrowDiff: 1px;            
            height: 0px;
            position: absolute;

        }
        .errorContainer:before{
            border-bottom: 8px solid #d73737;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            content: "";
            height: 0;
            left: 12px;
            position: absolute;
            top: -8px;
            width: 0;
        }
        .errorContainer{
            min-height: 25px;
            background: #d73737;
            position: relative;
            -moz-border-radius: 10px;
            -webkit-border-radius: 10px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
            position: absolute;
            z-index: 4;
            top: var(--pic-errorTop);
        }
        .errorText{
            color: white;
            margin-left: 0.3rem;
            margin-right: 0.3rem;
        }
        img{
            margin-left: 0.3rem;
        }
        .hidden{
            display: none;
        }
        .fade-in{
            animation: fadeIn ease 0.3s;
            -webkit-animation: fadeIn ease 0.3s;
            -moz-animation: fadeIn ease 0.3s;
        }
        ul{
            padding-left: 1.23rem;
        }
        @keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        @-moz-keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        @-webkit-keyframes fadeIn {
            0% {opacity:0;}
            100% {opacity:1;}
        }
        .fade-out {
            opacity:0;
            animation: fadeOut ease 0.3s;
            -webkit-animation: fadeOut ease 0.3s;
            -moz-animation: fadeOut ease 0.3s;
        }
        @keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }
        @-moz-keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }
        @-webkit-keyframes fadeOut {
            0% {opacity:1;}
            100% {opacity:0;}
        }
        /* new style */
        .pic-error{
            color: var(--pic-statusErrorColor);
            margin-left: 16px;
            display: inline-flex;
            width: 90%;
        }
        .pic-errortxt{
            max-width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .pic-errormore{
            cursor: pointer;
            text-decoration: underline;
            min-width: 4rem;
        }
        .errorContainer.old{
            --pic-errorTop: calc(var(--pic-densityOldInputHeight) + var(--pic-densityOldLabelHeight) + 10px);
        }
        .pic-checkbox-error{
            --pic-errorArrowLeft: 8px!important; 
        }
        .pic-errorContainer:before{
            content: "";
            position: absolute;
            left: var(--pic-errorArrowLeft);
            bottom: var(--pic-errorArrowBottom);
            top: var(--pic-errorArrowTop);
            width: 0px;
            height: 0px;
            line-height: 0;
            border-width: var(--pic-errorArrowSize);
            border-style: dashed;
            border-image: initial;
            border-color: transparent transparent var(--pic-blackOverlayFocusColor);
        } 
        .pic-errorContainer:after{
            content: "";
            position: absolute;
            left: calc(var(--pic-errorArrowLeft));
            bottom: calc(var(--pic-errorArrowBottom) - var(--pic-errorArrowDiff));
            top: calc(var(--pic-errorArrowTop) + var(--pic-errorArrowDiff));
            width: 0px;
            height: 0px;
            border-width: var(--pic-errorArrowSize);
            border-style: dashed;
            border-color: transparent transparent var(--pic-surfaceColor);
            border-image: initial;
        }
        .suggestionError:before {
            bottom: -20px;
            top: unset;
            rotate: 180deg;
        }
        .suggestionError:after {
            bottom: -19px;
            top: unset;
            rotate: 180deg;

        }
        .pic-errorContainer{
            min-height: 25px;
            background: var(--pic-surfaceColor);
            position: relative;
            border: 1px solid var(--pic-blackOverlayFocusColor);
            border-radius: 2px;
            display: flex;
            align-items: center;
            position: absolute;
            z-index: 4;
            top: var(--pic-errorTop);
            left: var(--pic-errorLeft);
            width: max-content;
        }
        .pic-errorListText{
            color: var(--pic-statusErrorColor);
            margin-left: 0.3rem;
            margin-right: 0.3rem;
        }
        img{
            margin-left: 0.3rem;
        }
        .hidden{
            display: none;
        }
        .fade-in{
            animation: fadeIn ease 0.3s;
            -webkit-animation: fadeIn ease 0.3s;
            -moz-animation: fadeIn ease 0.3s;
        }
        ul{
            padding-left: 1.23rem;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    renderLI(iErr) {
        return html `<li>${iErr}</li>`;
    }
    handleend(e) {
        if (e.animationName == 'fadeOut') {
            this.state = 'hidden';
            this.requestUpdate();
        }
    }
    renderError() {
        var _a, _b, _c, _d;
        const dualSelectorStyling = {
            'top': '10px'
        };
        let topOutsideBounds = undefined;
        if (this.parent instanceof PICSuggestion || this.parent instanceof PICSelector) {
            const parentRect = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
            if (parentRect && parentRect.top < 150) { //arbitrary value to avoid issues with the error box being outside the viewport
                topOutsideBounds = {
                    /* 40 should be clientHeight, but not available at that point - the math is just for fun, breaks after 2*/
                    'top': (parentRect.top - 40 - (Math.pow(4, this.errorMessages.length))) + 'px',
                    'left': parentRect.left + 'px',
                    'position': 'fixed',
                };
            }
        }
        const errorStyling = topOutsideBounds != null
            ? topOutsideBounds
            : {
                'top': 'unset',
                'bottom': '6px',
            };
        const Error = {
            'suggestionError': this.parent instanceof PICSuggestion || this.parent instanceof PICSelector,
            'pic-errorContainer': true,
            'pic-checkbox-error': this.parent instanceof PICCheckBox,
            ['' + this.state]: true,
            ['' + ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.density)]: true,
        };
        if (((_c = this.parent) === null || _c === void 0 ? void 0 : _c.density) == 'inline') {
            return html `
                <div class="pic-errorContainer ${this.state} ${(_d = this.parent) === null || _d === void 0 ? void 0 : _d.density} ${this.parent instanceof PICCheckBox ? 'pic-checkbox-error' : ''}" @animationend=${this.handleend}>
                    <div class="pic-errorListText">
                        <ul>
                            ${this.errorMessages.map(m => this.renderLI(m.failMessage))}
                        </ul>
                    </div>
                </div> 
            `;
        }
        else {
            /*if (!this.showErrorBox && this.errorMessages.length >= 1) {
                return html`
                    <div @click=${() => this.parent?.focus()} style="width:100%; display:flex;">
                        <div class="pic-errortxt"> ${this.errorMessages[0].failMessage}</div>
                        ${this.errorMessages.length > 1?html`<div class="pic-errormore">${" + " + (this.errorMessages.length - 1) + " more"}</div>`:''}
                    </div>
                `;
            } else {*/
            return html `
                    <div 
                        style=${this.parent instanceof PICSelector && this.errorMessages.length > 0 && this.errorMessages[0].failMessage && this.errorMessages[0].failMessage.includes('Transfer failed - identical keys') ?
                styleMap(dualSelectorStyling) : '', this.parent instanceof PICSuggestion || this.parent instanceof PICSelector ? styleMap(errorStyling) : ''}
                        class=${classMap(Error)}
                        @animationend=${this.handleend}>
                        <div class="pic-errorListText">
                            <ul>
                                ${this.errorMessages.map(m => this.renderLI(m.failMessage))}
                            </ul>
                        </div>
                    </div>    
                `;
            /*}*/
        }
    }
    calcPos() {
        var _a, _b;
        let refElm = (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('.container');
        if (refElm && this)
            computePosition(refElm, this, {
                platform: Object.assign(Object.assign({}, platform), { getOffsetParent: (element) => platform.getOffsetParent(element, offsetParent) }),
                strategy: 'fixed',
                middleware: [
                    offset(9),
                ]
            }).then(({ x, y, placement }) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                let parentHeight = refElm.offsetHeight;
                let parentDisplay = refElm.style.getPropertyValue('display');
                if (parentHeight === 0 || parentDisplay === 'none') {
                    let densityHeight = ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.density) === 'inline' ? 26 : ((_b = this.parent) === null || _b === void 0 ? void 0 : _b.density) === 'high' ? 36 : ((_c = this.parent) === null || _c === void 0 ? void 0 : _c.density) === 'medium' ? 58 : ((_d = this.parent) === null || _d === void 0 ? void 0 : _d.density) === 'low' ? 66 : 0;
                    let inputHeight = ((_e = this.parent) === null || _e === void 0 ? void 0 : _e.density) === 'inline' ? 20 : ((_f = this.parent) === null || _f === void 0 ? void 0 : _f.density) === 'high' ? 20 : ((_g = this.parent) === null || _g === void 0 ? void 0 : _g.density) === 'medium' ? 36 : ((_h = this.parent) === null || _h === void 0 ? void 0 : _h.density) === 'low' ? 44 : 0;
                    let labelHeight = ((_j = this.parent) === null || _j === void 0 ? void 0 : _j.density) === 'high' ? 10 : ((_k = this.parent) === null || _k === void 0 ? void 0 : _k.density) === 'medium' ? 16 : ((_l = this.parent) === null || _l === void 0 ? void 0 : _l.density) === 'low' ? 16 : 0;
                    let rem = document.body ? parseFloat(window.getComputedStyle(document.body).fontSize) : 16;
                    if (this.parent instanceof PICText || this.parent instanceof PICSuggestion || this.parent instanceof PICNumber) {
                        if (densityHeight) {
                            y = y + densityHeight;
                        }
                    }
                    if (this.parent instanceof PICTextArea) {
                        if (inputHeight) {
                            y = y + (inputHeight * ((_m = this.parent) === null || _m === void 0 ? void 0 : _m.rows)) + (rem / 2) + labelHeight;
                        }
                    }
                    if (this.parent instanceof PICSelector) {
                        if (densityHeight) {
                            if (((_o = this.parent) === null || _o === void 0 ? void 0 : _o.selectType_) === 'spinner')
                                y = y + densityHeight;
                            else {
                                y = y + (((_p = this.parent) === null || _p === void 0 ? void 0 : _p.rows_) * 1.35 * rem) + 4 + labelHeight;
                            }
                        }
                    }
                }
                if (((_q = this.parent) === null || _q === void 0 ? void 0 : _q.density) === 'inline') {
                    y = parentHeight - 4;
                }
                else {
                    y = parentHeight + 10;
                }
                if (((_r = this.parent) === null || _r === void 0 ? void 0 : _r.density) === 'inline') {
                    let inlineLabel = (_s = this.parent.shadowRoot) === null || _s === void 0 ? void 0 : _s.querySelector('label');
                    this.style.setProperty('--pic-errorLeft', inlineLabel.getBoundingClientRect().width + 'px');
                    this.style.setProperty('--pic-errorTop', (y / 2) + 11 + 'px');
                }
                else {
                    this.style.setProperty('--pic-errorTop', y + 'px');
                }
            });
    }
    updated(_changedProperties) {
        super.updated(_changedProperties);
        this.calcPos();
    }
    render() {
        var _a, _b, _c, _d;
        if (this.parent instanceof PICSelector
            && this.errorMessages.length > 0
            && this.errorMessages[0].failMessage
            && this.errorMessages[0].failMessage.includes('Transfer failed - identical keys'))
            this.style.setProperty('position', 'relative');
        if (!this.parent || this.parent.eType == 'old') {
            return html `
                ${this.renderCSS(true)}
                <div class="errorContainer old ${this.state}" @animationend=${this.handleend}>
                    <img width="18" height="18" src="../images/Info.png">
                    <div class="errorText">
                        <ul>
                            ${this.errorMessages.map(m => this.renderLI(m.failMessage))}
                        </ul>
                    </div>
                </div>    
            `;
        }
        else {
            if (this.parent && this.parent.inputField && this.parent.inputField instanceof HTMLInputElement) {
                this.calcPos();
                if (this.errorMessages && this.errorMessages.length > 0) {
                    (_b = (_a = this.parent) === null || _a === void 0 ? void 0 : _a.inputField) === null || _b === void 0 ? void 0 : _b.setCustomValidity(this.errorMessages[0].failMessage);
                }
                else
                    (_d = (_c = this.parent) === null || _c === void 0 ? void 0 : _c.inputField) === null || _d === void 0 ? void 0 : _d.setCustomValidity('');
            }
            return html `
                ${this.renderCSS(true)}
                <div class="pic-caption pic-error">
                    ${this.renderError()}
                </div>
            `;
        }
    }
};
__decorate([
    query('.errorContainer')
], PICError.prototype, "container", void 0);
__decorate([
    property({ type: Array })
], PICError.prototype, "errorMessages", void 0);
__decorate([
    property({ type: Boolean })
], PICError.prototype, "showErrorBox", void 0);
PICError = __decorate([
    customElement('pic-error')
], PICError);
export { PICError };
//# sourceMappingURL=PICError.js.map